import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }

import { getCurrentInstance, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const app = getCurrentInstance()
const i18n = useI18n()

app!.appContext.config.globalProperties.i18n = i18n
app!.appContext.config.globalProperties.$t = i18n.t

onMounted(() => {
  try {
    navigator.serviceWorker.ready.then((registration) => {
      console.log('serviceWorker are ready', registration)
  
      registration.unregister()
          .then(() => {
            console.log('unregistered')
          })
          .catch(() => {
            console.log('error when unregistering')
          })
    })
  } catch (error) {
    console.log('CATCHED ERROR', error)
  }
})


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view)
  ]))
}
}

})